<template>
    <div>
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <h4 class="mb-sm-0">{{this.label}} Data Pelanggan</h4>
                                    <div class="page-title-right">
                                        <ol class="breadcrumb m-0">
                                            <li class="breadcrumb-item"><router-link :to="{name : 'customer'}">Data Pelanggan</router-link></li>
                                            <li class="breadcrumb-item active">Form</li>
                                        </ol>
                                    </div>
                                </div>

                                <form v-on:submit.prevent="onSubmit">
                                    <div class="row">
                                        <input type="hidden" name="id" v-model="form.id">
                                        <div class="form-group col-md-6 mt-3">
                                            <label for="exampleFormControlSelect1">Tipe Identitas</label>
                                            <select class="form-select" id="exampleFormControlSelect1" v-model="form.identity_type" :class="{ 'is-invalid': submitted && $v.form.identity_type.$error }">
                                                <option value="">Pilih Identitas</option>
                                                <option v-for="(item, index) in identityList" :key="index" >{{item}}</option>
                                            </select>
                                            <div v-if="submitted && !$v.form.identity_type.required" class="invalid-feedback">Tipe Identitas Wajib diisi!</div>    
                                        </div>

                                        <div class="form-group col-md-6 mt-3">
                                            <label>Nomor Identitas</label>
                                            <input type="text" class="form-control"
                                                placeholder="Masukan data..." v-model="form.identity_number" :class="{ 'is-invalid': submitted && $v.form.identity_number.$error }">
                                            <div v-if="submitted && !$v.form.identity_number.required" class="invalid-feedback">Nomor Identitas Wajib diisi!</div>    
                                            <div v-if="submitted && !$v.form.identity_number.numeric" class="invalid-feedback"> Nomor Identitas harus berupa angka</div>
                                        </div>

                                        <div class="form-group col-md-12 mt-3">
                                            <label>Nama</label>
                                            <input type="text" class="form-control"
                                                placeholder="Masukan data..." v-model="form.name" :class="{ 'is-invalid': submitted && $v.form.name.$error }">
                                            <div v-if="submitted && !$v.form.name.required" class="invalid-feedback">Nama Pelanggan Wajib diisi!</div>    
                                        </div>
                                    </div>
                                    <div class="button-items mt-3">
                                        <button type="submit" class="btn btn-primary" :disabled="waiting">
                                        <i class="fa fa-save"></i> {{ waiting ? 'Harap tunggu ...' : 'Simpan' }}</button>
                                        <router-link :to="{name : 'customer'}" class="btn btn-outline-primary">Kembali</router-link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        required, numeric
    } from "vuelidate/lib/validators";
    
    export default {
        name: 'customer',
        metaInfo: {
            title: 'Form Pelanggan',
            titleTemplate: '%s - Katarda'
        },
        created() {
            this.getDataByID(this.$route.params.id);
        },
        data() {
            return {
                label           : 'Tambah',
                form : {
                    id              : "",
                    name            : "",
                    identity_type   : "",
                    identity_number : ""
                },
                identityList    : [
                    'ktp','sim','pasport','lainnya'
                ],
                submitted       : false,
                waiting         : false
            }
        },
        validations: {
            form: {
                name: {
                    required
                },
                identity_type: {
                    required
                },
                identity_number: {
                    required,
                    numeric
                },
            }
        },
        methods: {
            onSubmit: function () {
                this.waiting    = true;
                this.submitted  = true;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Harap lengkapi form',
                    });

                    this.waiting = false;
                    return;
                } else {    
                    let formData = new FormData();

                    formData.append('id', this.form.id);
                    formData.append('name', this.form.name);
                    formData.append('identity_type', this.form.identity_type);
                    formData.append('identity_number', this.form.identity_number);

                    this.$http.post(process.env.VUE_APP_APIHOST + 'admin/customer/save', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                            if (response.data.status) {
                                this.$swal({
                                    icon: 'success',
                                    title: 'Success',
                                    text: response.data.message,
                                    confirmButtonText: 'OK'
                                }).then((result) => {
                                    if (result.value) {
                                        this.$router.push({ name: 'customer' });
                                    }
                                });
                            } else {
                                this.$swal({
                                    icon: 'warning',
                                    title: 'Ups!',
                                    text: response.data.message,
                                });
                            }
                            this.waiting = false;
                        })
                    .catch(function () {
                        this.$swal({
                            icon: 'warning',
                            title: 'Ups!',
                            text: 'Please check your internet connection.',
                        });
                        this.waiting = false;
                        return;
                    });

                }
            },
            getDataByID: function(id) {
                if (typeof (id) !== 'undefined' && id !== null) {
                    this.label  = "Ubah";

                    let uri     = process.env.VUE_APP_APIHOST+'admin/customer/detail';

                    this.dataFetch  = true;                
                    this.$http.get(uri,{
                        params : {
                            id : id
                        }
                    }).then(res => {
                        if(res.data.status) {
                            let getResponse = res.data.data;

                            this.form.id                = getResponse.id;
                            this.form.name              = getResponse.name;
                            this.form.identity_type     = getResponse.identity_type;
                            this.form.identity_number   = getResponse.identity_number;
                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: res.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.$router.push({ name: 'customer' });
                                }
                            });
                        }
                    });
                }
            }
        }
    }
</script>